import { NavLink, useNavigate } from "react-router-dom";
import { useCartStore } from "../store/cartStore";
import { useWishlistStore } from "../store/wishlistStore";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/my-account" },
  { label: "Account Details", path: "/my-account/profile" },
  { label: "Addresses", path: "/my-account/addresses" },
  { label: "Notifications", path: "/my-account/notifications" },
  { label: "Orders", path: "/my-account/orders" },
  { label: "Wishlist", path: "/my-account/wishlist" },
];

const MyAccountSidebarMobile = ({ isOpen, onClose }) => {
  const { clearCart } = useCartStore();
  const { clearWishlistLocal } = useWishlistStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("userType");
    clearCart();
    clearWishlistLocal();
    onClose();
    navigate("/login");
  };

  const handleNavClick = () => onClose();

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
          zIndex: 1040,
        }}
      />

      {/* Sidebar */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100%",
          width: 300,
          backgroundColor: "#fff",
          zIndex: 1050,
          overflowY: "auto",
        }}
        className="canvas-filter canvas-sidebar canvas-sidebar-account"
      >
        <div className="canvas-wrapper">
          <header className="canvas-header">
            <span className="title">MY ACCOUNT</span>
            <span
              className="icon-close icon-close-popup"
              onClick={onClose}
              style={{ cursor: "pointer" }}
            />
          </header>
          <div className="canvas-body sidebar-mobile-append">
            <ul className="my-account-nav">
              {NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                      `my-account-nav-item${isActive ? " active" : ""}`
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}

              <li>
                <button
                  onClick={handleLogout}
                  className="my-account-nav-item"
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyAccountSidebarMobile;
